import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet, Platform, StatusBar, TouchableOpacity, TextInput, FlatList, ActivityIndicator } from 'react-native';
import Btn from "../components/btn"

import Colors from '../constants/Colors';
import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons"
import { CheckIcon, Modal, NativeBaseProvider, Select, useMediaQuery } from 'native-base';
import { useDispatch, useSelector } from 'react-redux';
import { getCity, getState, logOut } from '../store/action/userLogin';
import { getAllService } from '../store/action/finalproduct';
import AsyncStorage from '@react-native-async-storage/async-storage';











const Service = (props) => {

    const tokens = useSelector((store) => store.userLogin.datatoken);
    const dispatch = useDispatch();

    const [showModal, setshowModal] = useState(false);

    const [dataSource, setDataSource] = useState([]);
    const [State, setState] = useState({
        showModal: false,
        favorit: true,
        isLoading: false,
        name: "",
        Ostan: props.route.params.ostany,
        City: props.route.params.citys,
        ActService: true,
        lowActwork: "",
        offset: 1

    })










    const [Statetag, setStatetag] = useState("")
    const setStatehandler = async () => {
        try {
            const tok = await dispatch(getState(
                tokens
            ))


            setStatetag(tok.data.data.states);
        } catch (err) {
            console.log(err);
        }
    };

    let fresh = []
    for (let i = 0; i < Statetag.length; i++) {
        fresh.push(
            <Select.Item key={i} _text={{
                style: { fontFamily: "Montserrat" }
            }} label={Statetag[i].state} value={Statetag[i].id} />
        )

    }




    const [Citytag, setCitytag] = useState("")
    const setCityhandler = async (id) => {
        try {
            setState({ ...State, Ostan: id })

            const tok = await dispatch(getCity(
                tokens,
                id
            ))

            setCitytag(tok.data.data.cities)
        } catch (err) {
            console.log(err);
        }

    };

    let Sectoring = []
    for (let i = 0; i < Citytag.length; i++) {
        Sectoring.push(
            <Select.Item key={i} _text={{
                style: { fontFamily: "Montserrat" }
            }} label={Citytag[i].city} value={Citytag[i].id} />
        )

    }



    const getSERVICEHandler = async () => {
        try {

            setState({ ...State, isLoading: true })

            const res = await dispatch(getAllService(tokens,
                State.offset,
                State.Ostan,
                State.City,
                State.ActService,
                State.lowActwork,
                State.name
            ));


            if (res.data.data.next_page_url) {
                setDataSource([...dataSource, ...res.data.data.services.data])
            } else {
                setDataSource([...res.data.data.services.data])
            }
            // console.log(res.data.data.services.data);
            setState({ ...State, isLoading: false })

        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        setStatehandler()

    }, [State.offset])














    const renderFooter = () => {
        return (

            <View style={styles.footer}>
                <TouchableOpacity
                    activeOpacity={0.9}
                    onPress={getSERVICEHandler}

                    style={styles.loadMoreBtn}>
                    <Text style={styles.btnText}>  خدماتی بیشتر </Text>
                    {State.isLoading ? (
                        <ActivityIndicator color="white" style={{ marginLeft: 8 }} />
                    ) : null}
                </TouchableOpacity>
            </View>
        );
    };







    const logOutHandler = async () => {
        try {

            await dispatch(logOut());
            await AsyncStorage.removeItem("access_token");
            props.navigation.navigate("splash");
        } catch (err) {
            console.log(err);
        }
    };














    useEffect(() => {

        getSERVICEHandler();

    }, [])

    const [isSmallScreen] = useMediaQuery({
        // minHeight: 280,
        // maxHeight: 480,
        maxWidth: 500
    });

    return (

        <NativeBaseProvider>


            <View style={{
                width: isSmallScreen ? "100%" : 500,
                height: "100%",
                backgroundColor: Colors.background,
                position: Platform.OS == "web" ? "fixed" : "relative"
            }}>


                <View style={styles.viewHeader}>
                    <StatusBar backgroundColor={Colors.primary} />
                    <TouchableOpacity onPress={() => props.navigation.goBack()} style={styles.menu}   >
                        <Ionicons name="arrow-forward-outline" size={25} color={Colors.background} />
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => props.navigation.goBack()} style={styles.textheader}>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, padding: "5%" }}>
                            انتخاب خدماتی
                        </Text>
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => setshowModal(true)} style={styles.filter}>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, padding: "5%" }}>
                            فیلتر
                        </Text>
                        <MaterialCommunityIcons name="sort-ascending" size={25} color={Colors.background} />
                    </TouchableOpacity>

                </View>


                <Modal justifyContent="center" size="lg"
                    isOpen={showModal} onClose={() => setshowModal(false)}>
                    <Modal.Content style={{ borderRadius: 30 }}>
                        <Modal.Body >

                            <View style={{ width: "100%", height: 400 }}>
                                <View style={{ width: "100%", height: 40, }}>
                                    <Text style={styles.textmodal}>انتخاب  فیلتر</Text>
                                    <Ionicons onPress={() => setshowModal(false)} name="close" size={20} color={Colors.black} />
                                </View>



                                <View style={{ width: "100%", height: 300, marginBottom: 10 }}>



                                    <View style={{
                                        flexDirection: "column",
                                        width: "100%",
                                        alignItems: "center",
                                        marginRight: "5%",
                                        bottom: 10

                                    }}>

                                        <View style={{
                                            width: "15%",
                                            height: 20,
                                            backgroundColor: Colors.background,
                                            alignItems: "center",
                                            zIndex: 2,
                                            left: Platform.OS === "web" ? "37%" : "33%",
                                            top: Platform.OS === "web" ? "10%" : "20%"

                                        }}>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.secondText3 }}>
                                                استان
                                            </Text>
                                        </View>

                                        {Platform.OS === "web" ?
                                            "" :
                                            <Ionicons name="chevron-down-outline" size={18} color={Colors.secondText3} style={{ zIndex: 2, top: "34%", right: "40%" }} />
                                        }



                                        <Select

                                            style={{ backgroundColor: Colors.background }}
                                            selectedValue={parseInt(State.Ostan)}
                                            w={Platform.OS === "web" ? 280 : "90%"}
                                            h={50}
                                            dropdownIcon={true}
                                            paddingRight={3}
                                            paddingLeft={Platform.OS === "web" ? "50%" : 0}
                                            borderColor={Colors.secondText3}
                                            borderWidth={1}
                                            bottom={1}

                                            fontFamily="Montserrat"
                                            fontSize={12}
                                            flexDirection="row-reverse"
                                            accessibilityLabel="استان خود را انتخاب کنید"
                                            placeholder="استان خود را انتخاب کنید"
                                            onValueChange={(Ostan) => setCityhandler(Ostan)}
                                            _selectedItem={{
                                                bg: Colors.primary,
                                                startIcon: <CheckIcon size={5} color={Colors.black} />,

                                            }}
                                        >

                                            {fresh}
                                        </Select>

                                    </View>







                                    <View style={{
                                        flexDirection: "column",
                                        width: "100%",
                                        alignItems: "center",
                                        marginRight: "5%",
                                        bottom: Platform.OS === "web" ? 10 : 20

                                    }}>

                                        <View style={{
                                            width: "10%",
                                            height: 20,
                                            backgroundColor: Colors.background,
                                            alignItems: "center",
                                            zIndex: 2,
                                            left: Platform.OS === "web" ? "37%" : "33%",
                                            top: Platform.OS === "web" ? "10%" : "20%"

                                        }}>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.secondText3 }}>
                                                شهر
                                            </Text>
                                        </View>

                                        {Platform.OS === "web" ?
                                            "" :
                                            <Ionicons name="chevron-down-outline" size={18} color={Colors.secondText3} style={{ zIndex: 2, top: "34%", right: "40%" }} />
                                        }



                                        <Select

                                            style={{ backgroundColor: Colors.background }}
                                            selectedValue={parseInt(State.City)}
                                            w={Platform.OS === "web" ? 280 : "90%"}
                                            h={50}
                                            dropdownIcon={true}
                                            paddingRight={3}
                                            paddingLeft={Platform.OS === "web" ? "55%" : 0}
                                            borderColor={Colors.secondText3}
                                            borderWidth={1}
                                            bottom={1}
                                            fontFamily="Montserrat"
                                            fontSize={12}
                                            flexDirection="row-reverse"
                                            accessibilityLabel="شهر خود را انتخاب کنید"
                                            placeholder="شهر خود را انتخاب کنید"
                                            onValueChange={(t) => setState({ ...State, City: t })}
                                            _selectedItem={{
                                                bg: Colors.primary,
                                                startIcon: <CheckIcon size={5} color={Colors.black} />,

                                            }}
                                        >


                                            {Sectoring}
                                        </Select>

                                    </View>


                                    <View style={{ width: Platform.OS === "web" ? "95%" : "92%", height: 40, marginBottom: 20, left: 13, flexDirection: "row", marginTop: Platform.OS === "web" ? 20 : 0 }}>
                                        <Ionicons onPress={() => setState({ ...State, ActService: !State.ActService })} name={State.ActService == false ? "square-outline" : 'checkbox'}
                                            size={28} color={State.ActService == false ? Colors.secondText3 : Colors.yellowlight} />


                                        <Text style={{ fontFamily: "MontserratBold", fontSize: 12, color: Colors.black, position: "absolute", right: 0 }}> خدماتی های فعال :</Text>
                                    </View>

                                    <View style={{ width: "91%", height: 40, marginBottom: 20, left: 13, flexDirection: "row", }}>
                                        <Ionicons onPress={() => setState({ ...State, lowActwork: !State.lowActwork })} name={State.lowActwork == false ? "square-outline" : 'checkbox'}
                                            size={28} color={State.lowActwork == false ? Colors.secondText3 : Colors.yellowlight} />

                                        <Text style={{ fontFamily: "MontserratBold", fontSize: 12, color: Colors.black, position: "absolute", right: 0 }}> ترافیک کاری پایین :</Text>
                                    </View>


                                </View>








                                <Btn
                                    touchableStyle={{
                                        width: "90%",
                                        height: 50,
                                        backgroundColor: Colors.primary,
                                    }}
                                    textStyle={{ bottom: 10, fontSize: 16 }}
                                    style={{ marginTop: 10, bottom: 10, left: 10 }}
                                    onPress={() => {

                                        setshowModal(false)
                                        getSERVICEHandler()


                                    }}
                                    colorspin={Colors.background}
                                    sizespin={25}
                                    label="ثبت"

                                />





                            </View>


                        </Modal.Body>

                    </Modal.Content>
                </Modal>

                <View style={{ flexDirection: "row", width: "100%", height: 70, marginBottom: 10 }}>

                    <TextInput

                        placeholder="جست وجو در خدماتی ها "
                        onKeyPress={getSERVICEHandler}
                        placeholderTextColor={Colors.secondText3}
                        style={styles.textinput}
                        onChangeText={(e) => setState({ ...State, name: e })}

                    />
                    <MaterialCommunityIcons name="magnify" size={30} color="#767F9D" style={{ position: "absolute", right: "8%", top: 30, zIndex: 2 }} />
                </View>


                {State.isLoading ? (
                    <ActivityIndicator color="red" style={{ marginLeft: 8 }} />
                ) :


                    dataSource.length == [] ?
                        <View style={{ width: "80%", height: 60, backgroundColor: Colors.primarydark, left: "10%", padding: 5, borderRadius: 10, marginTop: "10%" }}>
                            <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, textAlign: "center" }}>در محدوده شما خدماتی یافت نشد. لطفا از طریق فیلتر ، خدماتی بیشتر را جست و جو کنید.</Text>
                        </View>
                        :
                        <FlatList


                            data={dataSource}

                            onEndReachedThreshold={0.5}
                            onEndReached={() => setState({ ...State, offset: State.offset + 1 })}
                            ListFooterComponent={renderFooter}
                            enableEmptySections={true}
                            renderItem={({ item, index }) =>

                                <View key={index} style={styles.view}>
                                    <View style={{ width: "100%", height: 40, marginRight: "5%", marginTop: 5, justifyContent: 'center', flexDirection: "row" }}>
                                        <Text style={styles.texttitle}>{item.first_name} {item.last_name}</Text>

                                    </View>

                                    <View style={{ width: "90%", height: 1, backgroundColor: Colors.secondText2 }}></View>


                                    <View style={styles.viewline} >
                                        <Text style={styles.textlineR}>وضعیت خدماتی  : <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: item.active == "true" ? Colors.success : Colors.secondText3, }}>{item.active == "true" ? "فعال" : "غیر فعال"}</Text></Text>
                                    </View>

                                    <View style={styles.viewline} >

                                        <Text style={styles.textlineR}>آدرس : <Text style={styles.textline}>{item.state.state} , {item.city.city}</Text></Text>
                                    </View>

                                    <TouchableOpacity onPress={() => {
                                        props.navigation.navigate("detailsService", {
                                            ids: item.id
                                        })
                                    }} style={styles.viewline} >
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.primary, position: "absolute", right: 50 }}> مشاهده جزئیات خدماتی</Text>
                                        <Ionicons name="eye-outline" size={20} color={Colors.primary} style={{ position: "absolute", right: 20, top: Platform.OS === "web" ? -1 : 4 }} />
                                    </TouchableOpacity>


                                    <View style={styles.viewbtn} >
                                        <Btn
                                            label="انتخاب"
                                            nameicon="check"
                                            sizeicon={18}
                                            coloricon={Colors.background}
                                            styleicon={{ position: "absolute", left: Platform.OS === "web" ? 20 : 15, top: Platform.OS === "web" ? 0 : 4, }}
                                            touchableStyle={{ backgroundColor: Colors.green, elevation: 0, borderRadius: 30 }}
                                            style={{ width: "30%", height: 45, marginLeft: "5%", position: 'absolute', right: "65%" }}
                                            textStyle={{ color: Colors.background, right: 10, marginRight: Platform.OS === "web" ? 10 : 0 }}
                                            onPress={() => {
                                                props.navigation.navigate("final", {
                                                    name: item.first_name,
                                                    family: item.last_name,
                                                    totalmdf: props.route.params.totalmdf,
                                                    ids: item.id,
                                                    numberic: props.route.params.number

                                                })
                                            }}



                                        />

                                    </View>

                                </View>




                            }
                            keyExtractor={(item, index) => index.toString()}

                        />
                }




            </View>
        </NativeBaseProvider>

    );
}

const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background,
        position: Platform.OS == "web" ? "fixed" : "relative"
    },
    viewHeader: {
        flexDirection: "row",
        width: "100%",
        height: Platform.OS == "web" ? 60 : 80,
        backgroundColor: Colors.primary,
    },

    menu: {
        backgroundColor: Colors.primary,
        width: 40,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 15,
        top: Platform.OS == "web" ? "15%" : "35%",

    },
    textheader: {
        backgroundColor: Colors.primary,
        width: 110,
        height: 40,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "12%",
        top: Platform.OS == "web" ? "15%" : "35%"
    },

    textinput: {
        paddingLeft: Platform.OS === "web" ? "35%" : 0,
        flexDirection: "row",
        width: "90%",
        height: 60,
        backgroundColor: Colors.background2,
        position: "absolute",
        left: "5%",
        borderRadius: 10,
        borderWidth: 1,
        borderColor: Colors.secondText3,
        padding: 10,
        paddingRight: 50,
        fontFamily: "Montserrat",
        marginTop: 15,


    },


    view: {
        flexDirection: "column",
        alignItems: "center",
        width: "90%",
        height: 200,
        backgroundColor: Colors.background1,
        marginTop: 10,
        left: "5%",
        borderWidth: 1,
        borderColor: Colors.secondText,
        borderRadius: 10,
        elevation: 2,
        marginBottom: 10

    },


    texttitle: {
        fontFamily: "Montserrat",
        fontSize: 15,
        color: Colors.black,
        position: "absolute",
        right: "3%",
        top: "15%"
    }
    ,
    viewline: {
        width: "100%",
        height: 30,
        justifyContent: "center",
        flexDirection: "row",
        marginTop: 5

    },
    textmodal: {
        fontFamily: "Montserrat",
        fontSize: 16,
        color: Colors.black,
        position: "absolute",
        right: "1%",
        top: "5%"
    },

    textlineR: {
        fontFamily: "Montserrat",
        fontSize: 13,
        color: Colors.black,
        position: "absolute",
        right: "5%"

    },
    textline: {
        fontFamily: "Montserrat",
        fontSize: 13,
        color: Colors.secondText3,

    },

    viewbtn: {
        width: "100%",
        height: 50,
        justifyContent: "center",
        flexDirection: "row",


    },
    filter: {
        backgroundColor: Colors.primary,
        width: 110,
        height: 40,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
        position: "absolute",
        left: "0%",
        top: Platform.OS == "web" ? "15%" : "35%"
    },
    footer: {
        padding: 10,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
    },
    loadMoreBtn: {
        padding: 10,
        backgroundColor: Colors.primary,
        borderRadius: 4,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    btnText: {
        color: Colors.background,
        fontSize: 15,
        textAlign: 'center',
        fontFamily: "MontserratBold",
    },
})




export default Service